import { createSlice } from '@reduxjs/toolkit';
import { xor } from 'lib';
import {
  handleResetFilter,
  handleSetSelectedItems,
  handleSetSelectedFilterIds,
  handleSetSelectedFilterValue,
  handleToggleCollapsed,
  handleSetSelectedContentBasedValues,
  handleSetSelectedCategories,
  handleChangeSortBy,
  handleSetSelectedSentimentValues,
} from 'store/helpers/filterHelpers';
import { handleApplySettingsFilters } from './contentHelpers';
import { nativePlatformFiltersInitialState } from './initialState/nativePlatformsContentInitialState';

export { nativePlatformFiltersInitialState as filtersInitialState };
export const nativePlatformsContentInitialState = {
  selectedNativePlatforms: [],
  filters: nativePlatformFiltersInitialState,
  sortBy: {
    selected: 'time',
    order: 'desc',
  },
  selectedFilter: 'contentTagFilter',
};
export const nativePlatformsContentSlice = createSlice({
  name: 'nativePlatformsContentSlice',
  initialState: nativePlatformsContentInitialState,
  reducers: {
    setSelectedNativePlatform: (state, action) => {
      const { id, isSingle = false } = action.payload;
      if (isSingle) {
        state.selectedNativePlatforms = [id];
        return;
      }
      state.selectedNativePlatforms = xor(state.selectedNativePlatforms, [id]);
    },
    setSelectedFilterIds: (state, action) => {
      handleSetSelectedFilterIds(state, action);
    },
    setSelectedItems: (state, action) => {
      handleSetSelectedItems(state, action);
    },
    setSelectedFilterValue: (state, action) => {
      handleSetSelectedFilterValue(
        state,
        action,
        nativePlatformFiltersInitialState
      );
    },
    setSelectedSentimentValues: (state, action) => {
      handleSetSelectedSentimentValues(state, action);
    },
    setSelectedContentBasedValues: (state, action) => {
      handleSetSelectedContentBasedValues(state, action);
    },
    setSelectedCategories: (state, action) => {
      handleSetSelectedCategories(state, action);
    },
    changeSortBy: (state, action) => {
      handleChangeSortBy(state, action);
    },
    toggleCollapsed: (state, action) => {
      handleToggleCollapsed(state, action);
    },
    resetAllFilters: (state) => {
      state.filters = nativePlatformFiltersInitialState;
    },
    resetFilter: (state, action) => {
      handleResetFilter(state, action, nativePlatformFiltersInitialState);
    },
    applyWebsiteSettingsFilters: (state, action) => {
      handleApplySettingsFilters(state, action);
    },
    setSelectedFilter: (state, action) => {
      state.selectedFilter = action.payload;
    },
  },
});

export const {
  setSelectedNativePlatform,
  setSelectedFilterIds,
  setSelectedItems,
  toggleCollapsed,
  resetAllFilters,
  resetFilter,
  setSelectedFilterValue,
  setSelectedCategories,
  setSelectedContentBasedValues,
  changeSortBy,
  applyWebsiteSettingsFilters,
  setSelectedFilter,
  setSelectedSentimentValues,
} = nativePlatformsContentSlice.actions;
